export default __webpack_public_path__ + "static/media/invite-icon.b6658c65.svg";